import React, { useState, useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { Alert, Button, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import "./dialogue.css"

const ConfirmationDialog = ({
  isOpen,
  title,
  message,
  remarksLabel,
  confirmBtnText = "Yes",
  cancelBtnText = "No",
  onConfirm,
  onCancel,
  t,
}) => {
  const [remarks, setRemarks] = useState("");
  
  useEffect(() => {
    if (isOpen) {
      setRemarks("");
    }
  }, [isOpen]);

  const handleValidSubmit = (event, values) => {
    onConfirm(values.remarks);
  };

  return (
    <Modal isOpen={isOpen} toggle={onCancel} centered className="confirmation-dialog">
      <ModalHeader toggle={onCancel} className="border-bottom-0 pb-0">
        {t(title)}
      </ModalHeader>
      <AvForm onValidSubmit={handleValidSubmit}>
        <ModalBody className="pt-4">
          <FormGroup className="mb-4">
            <Label for="remarks" className="mb-2 fw-medium">
              {t(remarksLabel)}
            </Label>
            <AvField
              type="textarea"
              name="remarks"
              id="remarks"
              rows="3"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder={t("Enter your remarks here...")}
              validate={{
                required: {
                  value: true, 
                  errorMessage: t("Remarks are required.")
                },
                pattern: {
                  value: /^[a-zA-Z0-9\s.,!?]*$/,
                  errorMessage: t("Special characters are not allowed.")
                },
                minLength: {
                  value: 3,
                  errorMessage: t("Remarks must be at least 3 characters.")
                }
              }}
              style={{ resize: "none" }}
            />
          </FormGroup>

          <Alert color="warning" className="d-flex align-items-center mb-0">
            <i className="bx bxs-error mr-2"></i>
            <span>{t(message)}</span>
          </Alert>
        </ModalBody>
        <ModalFooter className="border-top-0 pt-0">
          <Button color="secondary" onClick={onCancel} className="me-2">
            {t(cancelBtnText)}
          </Button>
          <Button color="primary" type="submit">
            {t(confirmBtnText)}
          </Button>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

export default withNamespaces()(ConfirmationDialog);